/* eslint react-hooks/exhaustive-deps: 0 */
import React, { Component } from 'react';
import { withTranslation } from 'react-i18next';
import { WhatsAppOutlined } from '@ant-design/icons';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { NavLink } from 'react-router-dom';

import { logoutRequest } from 'ducks/auth';
import { StyledDrawer, StyledButton, MenuItem } from 'components/Styled';

const linkStyle = {
  color: '#2C2C2E'
};

const linkStyleActive = {
  color: '#9900A5',
  fontWeight: 700
};

class Sidebar extends Component {
  componentDidUpdate(prevProps, prevState, snapshot) {
    if (!prevProps.logoutSuccess && this.props.logoutSuccess) {
      window.location.href = '/create-shipment';
    }
  }

  handleLanguageChange = lang => {
    if (localStorage.i18nextLng === lang) return;
    const pathname = this.props.location.pathname.replace(
      `/${localStorage.i18nextLng}`,
      `/${lang}`
    );
    this.props.history.push(`${process.env.PUBLIC_URL}${pathname}`);
    this.props.i18n.changeLanguage(lang);
    this.props.onClose();
  };

  render() {
    return (
      <StyledDrawer
        placement="right"
        onClose={this.props.onClose}
        visible={this.props.visible}
        closable={true}
        width={'60%'}>
          <div
            style={{
              padding: '20px 10px 45px',
              display: 'flex',
              flexDirection: 'column',
              justifyContent: 'space-between',
              height: '100%'
            }}>
            {this.props.user ? (
              <React.Fragment>
                <MenuItem>
                  {this.props.name}
                  <br />
                  <span style={{ color: '#2C2C2E', fontSize: '12px' }}>
                    {this.props.email}
                  </span>
                </MenuItem>
                <MenuItem>
                  <div style={linkStyle}>
                    <span
                      style={{ cursor: 'pointer' }}
                      onClick={() => this.handleLanguageChange('en')}>
                      ENG
                    </span>
                    {' / '}
                    <span
                      style={{ cursor: 'pointer' }}
                      onClick={() => this.handleLanguageChange('zh')}>
                      中文
                    </span>
                  </div>
                </MenuItem>
                <MenuItem>
                  <NavLink
                    style={linkStyle}
                    activeStyle={linkStyleActive}
                    onClick={this.props.onClose}
                    to={`${process.env.PUBLIC_URL}/create-shipment/quotation`}>
                    {this.props.t('sidebar.quotation')}
                  </NavLink>
                </MenuItem>
                <MenuItem>
                  <NavLink
                    style={linkStyle}
                    activeStyle={linkStyleActive}
                    onClick={this.props.onClose}
                    to={`${process.env.PUBLIC_URL}/account/orders`}>
                    {this.props.t('sidebar.booking')}
                  </NavLink>
                </MenuItem>
                <MenuItem>
                  <NavLink
                    style={linkStyle}
                    activeStyle={linkStyleActive}
                    onClick={this.props.onClose}
                    to={`${process.env.PUBLIC_URL}/account/payment-methods`}>
                    {this.props.t('sidebar.payment')}
                  </NavLink>
                </MenuItem>
                <MenuItem>
                  <NavLink
                    style={linkStyle}
                    activeStyle={linkStyleActive}
                    onClick={this.props.onClose}
                    to={`${process.env.PUBLIC_URL}/account/promo-codes`}>
                    {this.props.t('sidebar.promo_codes')}
                  </NavLink>
                </MenuItem>
              </React.Fragment>
            ) : (
              <React.Fragment>
                <MenuItem>
                  <div style={linkStyle}>
                    <span
                      style={{ cursor: 'pointer' }}
                      onClick={() => this.handleLanguageChange('en')}>
                      ENG
                    </span>
                    {' / '}
                    <span
                      style={{ cursor: 'pointer' }}
                      onClick={() => this.handleLanguageChange('zh')}>
                      中文
                    </span>
                  </div>
                </MenuItem>
                <MenuItem>
                  <NavLink
                    style={linkStyle}
                    activeStyle={linkStyleActive}
                    onClick={this.props.onClose}
                    to={`${process.env.PUBLIC_URL}/create-shipment/quotation`}>
                    {this.props.t('sidebar.quotation')}
                  </NavLink>
                </MenuItem>
                <MenuItem>
                  <NavLink
                    style={linkStyle}
                    activeStyle={linkStyleActive}
                    onClick={this.props.onClose}
                    to={`${process.env.PUBLIC_URL}/login`}>
                    {this.props.t('sidebar.login')}
                  </NavLink>
                </MenuItem>
                <MenuItem>
                  <NavLink
                    style={linkStyle}
                    activeStyle={linkStyleActive}
                    onClick={() => {
                      document.location.href = 'https://ship.spaceshipapp.com/signup';
                    }}
                    to={{ pathname: 'https://ship.spaceshipapp.com/signup' }}>
                    {this.props.t('sidebar.register')}
                  </NavLink>
                </MenuItem>
              </React.Fragment>
            )}
            <MenuItem style={{ flex: '1 1 auto' }}>
              <a style={linkStyle} href={`/`}>
                {this.props.t('sidebar.home')}
              </a>
            </MenuItem>
            {/* <MenuItem style={{ fontSize: '14px' }}>
              {this.props.t('sidebar.hotline')}
              <br />
              <a style={{ color: '#9900A5' }} href="tel:37053123">
                37053123
              </a>
            </MenuItem> */}
            <MenuItem style={{ fontSize: '14px' }}>
              {this.props.t('sidebar.contact_us')}
              <br />
              <a style={{ color: '#9900A5' }} href="mailto:hello@spaceshipapp.com">
                hello@spaceshipapp.com
              </a>
            </MenuItem>
            {this.props.user && (
              <MenuItem style={{ fontSize: '14px' }}>
                <span
                  style={{ cursor: 'pointer' }}
                  onClick={() => {
                    this.props.logoutRequest();
                    this.props.onClose();
                  }}>
                  {this.props.t('sidebar.logout')}
                </span>
              </MenuItem>
            )}
          </div>
      </StyledDrawer>
    );
  }
}

const mapStateToProps = state => {
  return {
    user: state.auth.user || false,
    email: state.auth.email || '',
    name: state.auth.name || '',
    logoutSuccess: !!state.auth.logoutSuccess
  };
};

const mapDispatchToProps = {
  logoutRequest
};

export default withTranslation()(
  connect(mapStateToProps, mapDispatchToProps)(withRouter(Sidebar))
);
